export const calendarData = {
  // Workspace data
  workspaces: [
    {
      id: 1,
      name: "Executive Suite A",
      location: "Horizons Offices - Floor 12",
      type: "workspace",
      capacity: "1 person",
      amenities: ["Private Office", "High-Speed WiFi", "Phone Line", "Printer Access"],
      hourlyRate: 45,
      image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=100&h=100&fit=crop",
    },
    {
      id: 2,
      name: "Creative Studio B",
      location: "Horizons Offices - Floor 8",
      type: "workspace",
      capacity: "2-3 people",
      amenities: ["Open Space", "Whiteboard", "Natural Light", "Coffee Station"],
      hourlyRate: 35,
      image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=100&h=100&fit=crop",
    },
    {
      id: 3,
      name: "Innovation Hub C",
      location: "Horizons Offices - Floor 5",
      type: "workspace",
      capacity: "4-6 people",
      amenities: ["Collaboration Space", "Smart TV", "Video Conferencing", "Snack Bar"],
      hourlyRate: 55,
      image: "https://images.unsplash.com/photo-1497366412874-3415097a27e7?w=100&h=100&fit=crop",
    },
    {
      id: 4,
      name: "Quiet Zone D",
      location: "Horizons Offices - Floor 3",
      type: "workspace",
      capacity: "1-2 people",
      amenities: ["Silent Area", "Ergonomic Furniture", "Reading Light", "Power Outlets"],
      hourlyRate: 25,
      image: "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=100&h=100&fit=crop",
    },
    {
      id: 5,
      name: "Tech Lab E",
      location: "Horizons Offices - Floor 10",
      type: "workspace",
      capacity: "3-4 people",
      amenities: ["High-Tech Setup", "Multiple Monitors", "3D Printer", "Development Tools"],
      hourlyRate: 65,
      image: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=100&fit=crop",
    },
  ],

  // Meeting room data
  meetingRooms: [
    {
      id: 6,
      name: "Conference Room Alpha",
      location: "Horizons Offices - Floor 15",
      type: "meeting_room",
      capacity: "12 people",
      amenities: ["Large Table", "Projector", "Video Conferencing", "Catering Service"],
      hourlyRate: 85,
      image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=100&h=100&fit=crop",
    },
    {
      id: 7,
      name: "Meeting Room Beta",
      location: "Horizons Offices - Floor 12",
      type: "meeting_room",
      capacity: "8 people",
      amenities: ["Round Table", "Whiteboard", "Smart TV", "Coffee Machine"],
      hourlyRate: 65,
      image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=100&h=100&fit=crop",
    },
    {
      id: 8,
      name: "Board Room Gamma",
      location: "Horizons Offices - Floor 20",
      type: "meeting_room",
      capacity: "20 people",
      amenities: ["Executive Setup", "Premium AV", "Catering Kitchen", "City View"],
      hourlyRate: 120,
      image: "https://images.unsplash.com/photo-1497366412874-3415097a27e7?w=100&h=100&fit=crop",
    },
    {
      id: 9,
      name: "Huddle Room Delta",
      location: "Horizons Offices - Floor 7",
      type: "meeting_room",
      capacity: "4 people",
      amenities: ["Intimate Setting", "Video Call Setup", "Comfortable Seating", "Privacy Glass"],
      hourlyRate: 45,
      image: "https://images.unsplash.com/photo-1556761175-4b46a572b786?w=100&h=100&fit=crop",
    },
    {
      id: 10,
      name: "Training Room Epsilon",
      location: "Horizons Offices - Floor 6",
      type: "meeting_room",
      capacity: "25 people",
      amenities: ["Classroom Style", "Multiple Screens", "Sound System", "Breakout Areas"],
      hourlyRate: 95,
      image: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=100&fit=crop",
    },
  ],

  // Sample bookings data
  bookings: [
    // Today's bookings
    {
      id: 1,
      name: "Sarah Johnson",
      email: "sarah.johnson@techcorp.com",
      phone: "+1 (555) 123-4567",
      company: "TechCorp Solutions",
      startTime: new Date(new Date().setHours(9, 0, 0, 0)),
      endTime: new Date(new Date().setHours(11, 0, 0, 0)),
      date: new Date(new Date().setHours(0, 0, 0, 0)),
      workspaceId: 1,
      status: "confirmed",
      purpose: "Client Presentation",
      notes: "Need projector setup and coffee service",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face",
      totalAmount: 90,
      paymentStatus: "paid",
    },
    {
      id: 2,
      name: "Michael Chen",
      email: "michael.chen@designstudio.com",
      phone: "+1 (555) 234-5678",
      company: "Creative Design Studio",
      startTime: new Date(new Date().setHours(14, 0, 0, 0)),
      endTime: new Date(new Date().setHours(16, 30, 0, 0)),
      date: new Date(new Date().setHours(0, 0, 0, 0)),
      workspaceId: 2,
      status: "confirmed",
      purpose: "Design Workshop",
      notes: "Creative session with team",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
      totalAmount: 87.5,
      paymentStatus: "paid",
    },
    {
      id: 3,
      name: "Emily Rodriguez",
      email: "emily.rodriguez@startup.io",
      phone: "+1 (555) 345-6789",
      company: "Innovation Startup",
      startTime: new Date(new Date().setHours(10, 0, 0, 0)),
      endTime: new Date(new Date().setHours(12, 0, 0, 0)),
      date: new Date(new Date().setHours(0, 0, 0, 0)),
      workspaceId: 6,
      status: "confirmed",
      purpose: "Investor Meeting",
      notes: "Important pitch presentation",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
      totalAmount: 170,
      paymentStatus: "paid",
    },

    // Tomorrow's bookings
    {
      id: 4,
      name: "David Wilson",
      email: "david.wilson@consulting.com",
      phone: "+1 (555) 456-7890",
      company: "Wilson Consulting",
      startTime: new Date(new Date(Date.now() + 24 * 60 * 60 * 1000).setHours(9, 30, 0, 0)),
      endTime: new Date(new Date(Date.now() + 24 * 60 * 60 * 1000).setHours(12, 0, 0, 0)),
      date: new Date(new Date(Date.now() + 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)),
      workspaceId: 3,
      status: "confirmed",
      purpose: "Strategy Session",
      notes: "Quarterly planning meeting",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
      totalAmount: 137.5,
      paymentStatus: "pending",
    },
    {
      id: 5,
      name: "Lisa Thompson",
      email: "lisa.thompson@marketing.co",
      phone: "+1 (555) 567-8901",
      company: "Marketing Pro",
      startTime: new Date(new Date(Date.now() + 24 * 60 * 60 * 1000).setHours(15, 0, 0, 0)),
      endTime: new Date(new Date(Date.now() + 24 * 60 * 60 * 1000).setHours(17, 0, 0, 0)),
      date: new Date(new Date(Date.now() + 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)),
      workspaceId: 7,
      status: "pending",
      purpose: "Campaign Review",
      notes: "Monthly campaign analysis",
      avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=face",
      totalAmount: 130,
      paymentStatus: "pending",
    },

    // Day after tomorrow
    {
      id: 6,
      name: "Robert Kim",
      email: "robert.kim@techventures.com",
      phone: "+1 (555) 678-9012",
      company: "Tech Ventures",
      startTime: new Date(new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).setHours(11, 0, 0, 0)),
      endTime: new Date(new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).setHours(13, 30, 0, 0)),
      date: new Date(new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)),
      workspaceId: 5,
      status: "confirmed",
      purpose: "Product Demo",
      notes: "Technical demonstration for clients",
      avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face",
      totalAmount: 162.5,
      paymentStatus: "paid",
    },
    {
      id: 7,
      name: "Amanda Foster",
      email: "amanda.foster@lawfirm.com",
      phone: "+1 (555) 789-0123",
      company: "Foster & Associates",
      startTime: new Date(new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).setHours(14, 0, 0, 0)),
      endTime: new Date(new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).setHours(16, 0, 0, 0)),
      date: new Date(new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)),
      workspaceId: 8,
      status: "confirmed",
      purpose: "Legal Consultation",
      notes: "Confidential client meeting",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
      totalAmount: 240,
      paymentStatus: "paid",
    },

    // Next week bookings
    {
      id: 8,
      name: "James Martinez",
      email: "james.martinez@finance.com",
      phone: "+1 (555) 890-1234",
      company: "Martinez Financial",
      startTime: new Date(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).setHours(10, 0, 0, 0)),
      endTime: new Date(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).setHours(12, 30, 0, 0)),
      date: new Date(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)),
      workspaceId: 4,
      status: "confirmed",
      purpose: "Financial Planning",
      notes: "Quarterly financial review",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
      totalAmount: 62.5,
      paymentStatus: "paid",
    },
    {
      id: 9,
      name: "Rachel Green",
      email: "rachel.green@healthtech.com",
      phone: "+1 (555) 901-2345",
      company: "HealthTech Solutions",
      startTime: new Date(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).setHours(13, 0, 0, 0)),
      endTime: new Date(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).setHours(15, 30, 0, 0)),
      date: new Date(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)),
      workspaceId: 9,
      status: "pending",
      purpose: "Team Standup",
      notes: "Weekly team synchronization",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face",
      totalAmount: 112.5,
      paymentStatus: "pending",
    },
    {
      id: 10,
      name: "Kevin Brown",
      email: "kevin.brown@education.org",
      phone: "+1 (555) 012-3456",
      company: "Education First",
      startTime: new Date(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).setHours(16, 0, 0, 0)),
      endTime: new Date(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).setHours(18, 0, 0, 0)),
      date: new Date(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)),
      workspaceId: 10,
      status: "confirmed",
      purpose: "Training Workshop",
      notes: "Educational content development",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
      totalAmount: 190,
      paymentStatus: "paid",
    },
  ],

  // Calendar statistics
  statistics: {
    totalBookings: 10,
    confirmedBookings: 7,
    pendingBookings: 2,
    cancelledBookings: 1,
    totalRevenue: 1481.0,
    averageBookingDuration: 2.5,
    occupancyRate: 68,
    popularTimeSlots: ["10:00 AM - 12:00 PM", "2:00 PM - 4:00 PM"],
    topWorkspaces: [
      { id: 1, name: "Executive Suite A", bookings: 2 },
      { id: 6, name: "Conference Room Alpha", bookings: 2 },
      { id: 2, name: "Creative Studio B", bookings: 1 },
    ],
  },

  // Available time slots for booking
  timeSlots: [
    { time: "06:00 AM", hour: 6, available: true },
    { time: "07:00 AM", hour: 7, available: true },
    { time: "08:00 AM", hour: 8, available: true },
    { time: "09:00 AM", hour: 9, available: true },
    { time: "10:00 AM", hour: 10, available: true },
    { time: "11:00 AM", hour: 11, available: true },
    { time: "12:00 PM", hour: 12, available: true },
    { time: "01:00 PM", hour: 13, available: true },
    { time: "02:00 PM", hour: 14, available: true },
    { time: "03:00 PM", hour: 15, available: true },
    { time: "04:00 PM", hour: 16, available: true },
    { time: "05:00 PM", hour: 17, available: true },
    { time: "06:00 PM", hour: 18, available: true },
    { time: "07:00 PM", hour: 19, available: true },
    { time: "08:00 PM", hour: 20, available: true },
    { time: "09:00 PM", hour: 21, available: true },
    { time: "10:00 PM", hour: 22, available: true },
    { time: "11:00 PM", hour: 23, available: true },
  ],

  // Booking status options
  statusOptions: ["confirmed", "pending", "cancelled", "completed"],

  // Payment status options
  paymentStatusOptions: ["paid", "pending", "overdue", "refunded"],
};
